/** レスポンスコード：6000 該当ページなし */
export const NOT_FOUND = 6000;
/** レスポンスコード：200 正常 */
export const HTTP_RESPONSE_CODE_OK = 200;
/** レスポンスコード：300 リダイレクト */
export const HTTP_RESPONSE_CODE_REDIRECT = 300;
/** レスポンスコード：422 バリデーションエラー */
export const HTTP_RESPONSE_CODE_VALIDATION_ERROR = 422;
/** レスポンスコード：500 サーバー内部エラー */
export const HTTP_RESPONSE_CODE_INTERNAL_SERVER_ERROR = 500;
/** エラーコード: 7000 バリデーションエラー */
export const VALIDATION_ERROR = 7000;
/** エラーコード: 3201 会員登録時の利用区分と許可ドメインが異なる（クライアント選択） */
export const BAD_DIVISION_CLIENT = 3201;
/** エラーコード: 3202 会員登録時の利用区分と許可ドメインが異なる（コンサルタント選択） */
export const BAD_DIVISION_PROFESSIONAL = 3202;
/** エラーコード: 3301 招待しようとしたユーザが削除済み */
export const BAD_RFP_OFFER_MEMBER_DELETED = 3301;
/** エラーコード: 3302 責任者を招待しようとしたが強制招待のフラグがない */
export const BAD_RFP_OFFER_MEMBER_ADMIN_NOT_HAS_FORCE_INVITE = 3302;
/** エラーコード: 3303 責任者の件数が異常 */
export const BAD_RFP_OFFER_MEMBER_INVALID_ADMIN_SETTING = 3303;
/** エラーコード: 3305 メールアドレスが重複している */
export const BAD_RFP_OFFER_MEMBER_DUPLICATE_EMAIL = 3305;
/** エラーコード: 3306 招待しようとしたユーザがクライアントなどで招待できない */
export const BAD_RFP_OFFER_MEMBER_CANT_INVITE_USER = 3306;
/** エラーコード: 3307 提案済みのユーザーを招待しようとしていた */
export const BAD_RFP_OFFER_MEMBER_HAS_OTHER_OFFER = 3307;
/** エラーコード: 3311 提案を誰かが更新中 */
export const BAD_RFP_OFFER_UPDATING = 3311;
/** エラーコード: 3502 パスワードリセットなどの有効期限切れ */
export const BAD_RESET_TOKEN_EXPIRED = 3502;
/** エラーコード: 4000 ログインエラー */
export const UNAUTHORIZED_LOGIN = 4000;
